import React from "react";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginForm";
import { API_BASE_URL } from "../api/client";
import { useAuth } from "../context/AuthContext";
import { useCartSummary } from "../context/CartContext";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { refresh: refreshCartBadge } = useCartSummary();

  const handleLoginSuccess = (data) => {
    login(data);
    refreshCartBadge();
    navigate("/");
  };

  return (
    <div className="auth-screen">
      <div className="brand">
        <img src="/onetak-icon.svg" alt="onetak" className="brand-icon" />
        <div className="brand-mark">one<span>tak</span></div>
      </div>
      <LoginForm apiBaseUrl={API_BASE_URL} onLoginSuccess={handleLoginSuccess} onGoJoin={() => navigate("/join")} />
      <p className="auth-switch">
        로그인 없이도 쇼핑할 수 있어요. <button type="button" className="link-btn" onClick={() => navigate("/")}>둘러보기</button>
      </p>
    </div>
  );
}
